import React from 'react';

const SIZE = 80;
const STROKE_WIDTH = 7;
const RADIUS = (SIZE - STROKE_WIDTH) / 2 - 2;
const CENTER = SIZE / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

/**
 * Circular progress ring for gateway uptime percentage.
 *
 * @param {{ value: number }} props  value between 0 and 100
 */
export default function UptimeWidget({ value = 0 }) {
  const clamped = Math.max(0, Math.min(100, value));
  const offset = CIRCUMFERENCE - (CIRCUMFERENCE * clamped) / 100;
  const displayValue = Number.isFinite(value) ? Math.round(value) : '--';

  return (
    <svg
      width={SIZE}
      height={SIZE}
      viewBox={`0 0 ${SIZE} ${SIZE}`}
      className="block"
      role="img"
      aria-label={`Uptime ${displayValue}%`}
    >
      <defs>
        <linearGradient id="uptimeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#34D399" />
          <stop offset="100%" stopColor="#059669" />
        </linearGradient>
      </defs>

      {/* Background ring */}
      <circle
        cx={CENTER}
        cy={CENTER}
        r={RADIUS}
        fill="none"
        stroke="#E5E7EB"
        strokeWidth={STROKE_WIDTH}
      />

      {/* Progress ring */}
      <circle
        cx={CENTER}
        cy={CENTER}
        r={RADIUS}
        fill="none"
        stroke="url(#uptimeGradient)"
        strokeWidth={STROKE_WIDTH}
        strokeLinecap="round"
        strokeDasharray={CIRCUMFERENCE}
        strokeDashoffset={offset}
        transform={`rotate(-90 ${CENTER} ${CENTER})`}
        style={{ transition: 'stroke-dashoffset 0.6s ease' }}
      />

      {/* Percentage text */}
      <text
        x={CENTER}
        y={CENTER - 2}
        textAnchor="middle"
        dominantBaseline="central"
        className="font-semibold"
        style={{ fontSize: 16, fill: '#1F2937' }}
      >
        {displayValue}
      </text>
      <text
        x={CENTER}
        y={CENTER + 14}
        textAnchor="middle"
        dominantBaseline="central"
        style={{ fontSize: 10, fill: '#9CA3AF' }}
      >
        %
      </text>
    </svg>
  );
}
